<template>
	<div class="page">

		<div class="page-content-wrap">

			<div class="content-place">

				<div class="row">
					<errors></errors>
				</div>
				
				<div class="row" style="position: relative;">
					<h3 id="s1" class="title-steps">Снимки</h3>
					<div class="col-lg-12 section-work" style="padding:0; ">
						<editor @exportContent="exportContent" :contentt="www.content"></editor>	

					</div>

				</div>

			</div>

			
		</div>
		

		<bottom-menu :www="www"></bottom-menu>
		<modal-create-folder v-if="modalCreateFolder"></modal-create-folder>

	</div>
</template>
<script>
	import ScrollTo from '../../../layouts/ScrollTo'
	import Errors from '../../../app_modules/Errors'
	import BottomMenu from '../../../app_modules/BottomMenu'

	import sortableImages from '../../../app_modules/SortableImages'

	import SortableProducts from '../../../app_modules/SortableProducts'

	import Forms from '../../../app_modules/Forms'
	import Editor from '../../../app_modules/EditorSlider'

	import axios from 'axios'

	export default {
		name: 'shop-category-create',
		components: {
			Forms,
			ScrollTo,
			Editor,
			Errors,
			sortableImages,
			BottomMenu,
			SortableProducts,
		},
		
		data() {
			return {
				openForms:false,

				www: {
					link_send: this.$store.getters.getDomainName+'shop/sell-company',
					method: 'post',
					redirect: 'shop-sell-company',
					// redirect: false,

					title: '',
					link: '',
					max_discount: '',
					status: true,
					products: [],
					images: [],
					date_start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() -1),
					date_end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() -1),
					content: `<h2>
					Описание за рекламна компания 
					</h2>`,

				},
				formElements: [
				{
					id: 0,
					type: 'input',
					name: 'title',
					placeholder: '',
					model: '',
				},
				{
					id: 1,
					type: 'input',
					name: 'link',
					placeholder: '',
					model: '',
				},
				{
					id: 2,
					type: 'input',
					name: 'max_discount',
					placeholder: '',
					model: '',
				},
				{
					id: 3,
					type: 'status',
					name: 'статус',
					model: true,
				},
				{
					id:4,
					name:'date_start',
					type: 'date_start', 
					model: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() -1),
				},
				{
					id:5,
					name: 'date_end',
					type: 'date', 
					model: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() -1),
				}

				],

				scrollTo: [
				{
					id: 1,
					name: 'мета дани',
					href: '#s1',
				},
				{
					id: 2,
					name: 'Контент',
					href: '#s2',
				},
				{
					id: 3,
					name: 'Продукти в компания',
					href: '#s3',
				},
				]
			}
		},
		methods: {
			unix_timestamp(t)
			{
				var dt = new Date(t*1000);
				var d = dt.getDate();
				var m =  dt.getMonth();
				m++
				var y = dt.getFullYear();
				return m+ '/' + d  + '/' + y;  
			},
			exportContent(data) {
				this.www.content = data
			},
			exportMeta(data) {

				this.www.title = data[0].model
				this.www.link = data[1].model
				this.www.max_discount = data[2].model
				this.www.status = data[3].model

				var el = data.filter(formElement => formElement.name == 'date_start')
				this.www.date_start = el[0].model

				var el2 = data.filter(formElement => formElement.name == 'date_end')
				this.www.date_end = el2[0].model
				console.log()

			},
			exportImages(data) {

				this.www.images = data
			},
			exportProducts(data) {

				this.www.products = data

			}
			
		},

		created() {
			
			if(this.$route.name == 'shop-sell-company-edit') {
				axios.get(this.$store.getters.getDomainName+'shop/sell-company/'+this.$route.params.id+'/edit')
				.then(response => {

					

					this.www.title = response.data['title']
					this.www.link = response.data['link']
					this.www.max_discount =response.data['max_discount']
					this.www.status = response.data['status']
					this.www.products = response.data['all_products']
					this.www.content = response.data['content']

					var images =  response.data['images'].split(";")
					images = images.reverse()

					for (var i = images.length - 1; i >= 0; i--) {
						this.www.images.push({ 
							icon: images[i],
							id: i,
						})

					}
					console.log(this.www.images)

					

					this.formElements[0].model = response.data['title']
					this.formElements[1].model = response.data['link']
					this.formElements[2].model = response.data['max_discount']
					this.formElements[3].model = response.data['status']

					this.formElements[4].model = this.unix_timestamp(response.data['date_start'])
					this.formElements[5].model = this.unix_timestamp(response.data['date_end'])
					console.log(response.data)

					this.www.date_start = this.unix_timestamp(response.data['date_start'])
					this.www.date_end = this.unix_timestamp(response.data['date_end'])




					console.log(this.formElements)

					this.www.link_send = this.$store.getters.getDomainName+'shop/sell-company/'+this.$route.params.id
					this.www.method = 'patch'
					eventBus.$emit('sendLinkAndMethod', this.www)
					this.openForms = true
					return

					
				})
				.catch(error => {
					// if(error.response.status == 404) {
					// 	this.$router.push({ name: '404' })
					// }


					// this.serverErrors = Object.values(error.response.data.errors)

					// iziToast.show({
					// 	theme: 'dark',
					// 	title: 'Грешка',
					// 	message: 'Инвалидни дани',
					// 	position: 'topRight', 
					// 	progressBarColor: 'rgb(255, 255, 255)',
					// 	icon: 'fa fa-exclamation-triangle',
					// });
				})
			} else {
				this.openForms = true
				return
			}
		},
		

	}
</script>

<style scoped>
@import url(../../../../assets/css/page-data.css);

.page-content-wrap {
	padding-left: 0;
}
.section-work {
	padding: 0;
	margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/system/web_modules/slider/data.vue